import { Phone, MessageCircle, MapPin, Mail, Instagram, Facebook } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer({ content }) {
    const year = new Date().getFullYear();
    return (
        <footer data-testid="site-footer" className="relative bg-[color:var(--surface-darker)] text-white pt-16 md:pt-24 pb-8 border-t border-white/10">
            <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3">
                            <img src={content.logo_url} alt="Steven R. Construction" className="h-14 w-auto" />
                            <div className="flex flex-col leading-none">
                                <span className="font-display font-bold text-base tracking-tight">HOME RENOVATION</span>
                                <span className="text-[10px] tracking-[0.25em] uppercase text-white/60 mt-1">Steven R. Construction LLC</span>
                            </div>
                        </div>
                        <p className="mt-6 text-sm text-white/70 max-w-sm leading-relaxed">
                            Home Renovation, concrete, flooring & painting. Greenwell Springs / Baton Rouge, LA. Licensed & Insured. As seen on <a href="https://www.homeadvisor.com/rated.HomeRenovationStevenR.118939782.html" target="_blank" rel="noreferrer" className="underline underline-offset-2 hover:text-[color:var(--brand-blue)]">HomeAdvisor</a>.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/50">Contact</div>
                        <ul className="mt-4 space-y-3 text-sm">
                            <li>
                                <a href={`tel:${content.phone_raw}`} className="flex items-center gap-2 hover:text-[color:var(--brand-blue)]">
                                    <Phone className="h-4 w-4" /> {content.phone}
                                </a>
                            </li>
                            <li>
                                <a href={`https://wa.me/${content.whatsapp}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[color:var(--brand-blue)]">
                                    <MessageCircle className="h-4 w-4" /> WhatsApp
                                </a>
                            </li>
                            {content.email && (
                                <li>
                                    <a href={`mailto:${content.email}`} className="flex items-center gap-2 hover:text-[color:var(--brand-blue)] break-all">
                                        <Mail className="h-4 w-4 shrink-0" /> {content.email}
                                    </a>
                                </li>
                            )}
                            <li className="flex items-center gap-2 text-white/70">
                                <MapPin className="h-4 w-4" /> {content.service_area}
                            </li>
                            <li className="text-white/70 pl-6 text-xs">
                                {content.hours || "Mon – Sat · 7:00 AM – 6:00 PM"}
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/50">Explore</div>
                        <ul className="mt-4 space-y-3 text-sm">
                            <li><a href="#services" className="hover:text-[color:var(--brand-blue)]">Services</a></li>
                            <li><a href="#gallery" className="hover:text-[color:var(--brand-blue)]">Gallery</a></li>
                            <li><a href="#reviews" className="hover:text-[color:var(--brand-blue)]">Reviews</a></li>
                            <li><a href="#contact" className="hover:text-[color:var(--brand-blue)]">Contact</a></li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/50">Follow</div>
                        <div className="mt-4 flex items-center gap-3">
                            <a href="#" aria-label="Facebook" className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/20 hover:border-[color:var(--brand-blue)] hover:text-[color:var(--brand-blue)] transition-colors">
                                <Facebook className="h-4 w-4" />
                            </a>
                            <a href="#" aria-label="Instagram" className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/20 hover:border-[color:var(--brand-blue)] hover:text-[color:var(--brand-blue)] transition-colors">
                                <Instagram className="h-4 w-4" />
                            </a>
                        </div>
                        <div className="mt-6">
                            <Link
                                to="/admin/login"
                                data-testid="footer-admin-link"
                                className="text-[10px] uppercase tracking-[0.3em] text-white/40 hover:text-white transition-colors"
                            >
                                Admin →
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] uppercase tracking-[0.25em] text-white/40">
                    <div>© {year} Home Renovation | Steven R. Construction LLC. All rights reserved.</div>
                    <div>Greenwell Springs · Baton Rouge · Louisiana</div>
                </div>
            </div>
        </footer>
    );
}
